import { useState } from "react";
import { Bell } from "lucide-react";
import { withFirstLetterCapitalized } from "@/lib/autoCapitalize";
import DeskConfirm, { R2_INPUT } from "@/components/crm/DeskConfirm";

/** AviReminderModal — relance manuelle d'un décideur (§4.7), note facultative — R2 (iter393). onConfirm(note). */
export default function AviReminderModal({ user, onClose, onConfirm }) {
  const [note, setNote] = useState("");
  const [saving, setSaving] = useState(false);
  const label = user ? `${user.first_name || ""} ${user.last_name || ""}`.trim() || user.email || "ce décideur" : "ce décideur";
  const submit = async () => {
    if (saving) return;
    setSaving(true);
    try { await onConfirm(note.trim() || null); } finally { setSaving(false); }
  };
  return (
    <DeskConfirm open danger={false} icon={Bell} title={`Relancer ${label} ?`} message="Une notification lui sera envoyée. Les relances sont illimitées et tracées dans l'historique." busy={saving}
      confirmLabel={saving ? "Envoi…" : "Envoyer la relance"} onClose={() => { if (!saving) onClose?.(); }} onConfirm={submit} testId="avi-reminder-modal">
      <textarea value={note} onChange={withFirstLetterCapitalized((e) => setNote(e.target.value))} rows={2} placeholder="Note (facultatif) — ex : c'est urgent, réponse attendue avant…" autoFocus
        className="resize-none placeholder:text-[#5a5a63]" style={R2_INPUT} data-testid="avi-reminder-note" />
    </DeskConfirm>
  );
}
